import {Box, Icon, TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, {useEffect, useState} from "react";

const EditMediaType = (props) => {
  const {mediaTypes, onMediaTypeSelect, defaultValue, disabled} = props;
  const [value, setValue] = useState(defaultValue || "");

  useEffect(() => {
    setValue(defaultValue || "");
  }, [defaultValue]);

  const compareAndSortMediaTypes = (mediaTypes) => {
    const mediaTypePhotoList = {
      MEDIA_TYPE_PHOTO_DAMAGE: 1,
      MEDIA_TYPE_PHOTO_ACCIDENT_SCENE: 2,
      MEDIA_TYPE_PHOTO_DURING_REPAIR: 3,
      MEDIA_TYPE_PHOTO_AFTER_REPAIR: 4,
    };

    return mediaTypes.sort((firstMediaType, secondMediaType) => {
      const isFirstTypeDocument = firstMediaType.parent?.code === "MEDIA_TYPE_DOCUMENT";
      const isSecondTypeDocument = secondMediaType.parent?.code === "MEDIA_TYPE_DOCUMENT";

      if (!isFirstTypeDocument && isSecondTypeDocument ) {
        return 1;
      }
      if (isFirstTypeDocument && !isSecondTypeDocument) {
        return -1;
      }
      if (isFirstTypeDocument && isSecondTypeDocument) {
        return 0;
      }

      return (mediaTypePhotoList[firstMediaType.code] || Infinity) - (mediaTypePhotoList[secondMediaType.code] || Infinity);
    });
  }

  const sortedMediaTypes = compareAndSortMediaTypes([...mediaTypes]);
  const selectedMediaType = sortedMediaTypes.find((mediaType) => mediaType.id === value) || null;

  const onChange = (event, selectedOption) => {
    if (!selectedOption) {
      return;
    }

    setValue(selectedOption.id);
    onMediaTypeSelect(selectedOption.id);
  };

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      disableClearable
      options={sortedMediaTypes}
      value={selectedMediaType}
      getOptionLabel={(mediaType) => mediaType.name || ""}
      onChange={onChange}
      renderOption={(mediaType) => (
        <Box display="flex" alignItems="center">
          <Icon
            className={ mediaType.parent.code === "MEDIA_TYPE_DOCUMENT" ? "fas fa-file" : "fas fa-image"}
            fontSize="small"
          />
          - {mediaType.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          placeholder="Yazarak ara"
        />
      )}
    />
  );

};

export default EditMediaType;
